function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5,9.85V9.30005A2.36833,2.36833,0,0,0,12,7.1,2.36833,2.36833,0,0,0,9.5,9.30005c0,.80994.29,1.79993,2.59,2.21,2.82.5,3.41,2.01,3.41,3.18994a3.2994,3.2994,0,0,1-3,3.16v1.38h-1V17.86a3.2994,3.2994,0,0,1-3-3.16v-.5h1v.5A2.36833,2.36833,0,0,0,12,16.9,2.36833,2.36833,0,0,0,14.5,14.7c0-.75-.27-1.79-2.59-2.21-2.26-.3999-3.41-1.48-3.41-3.18994a3.2994,3.2994,0,0,1,3-3.16V4.76h1V6.14a3.2994,3.2994,0,0,1,3,3.16V9.85Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_13818",
  "data-name": "Trazado 13818",
  className: "cls-1",
  d: "M0,0H24V24H0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12,3a9,9,0,1,1-9,9,9.01017,9.01017,0,0,1,9-9m0-1A10,10,0,1,0,22,12,10,10,0,0,0,12,2Z"
});

var SvgSalesOutline = function SvgSalesOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSalesOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sales_outline.a8522f73.svg";
export { ForwardRef as ReactComponent };